<template>
  <section>
    <header><h1>Contacts</h1></header>
    <new-friend @add-contact="addContact"></new-friend>
    <ul>
      <friend-contact
        v-for="friend in friends"
        :key="friend.id"
        :id="friend.id"
        :name="friend.name"
        :phone-number="friend.phone"
        :email-address="friend.email"
        :is-top="friend.isTop"
        @toggle-top="toggleTopStatus"
        @delete="deleteContact"
      ></friend-contact>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {
      friends: [
        {
          id: 'bob',
          name: 'Bob',
          phone: '0898 122 334',
          email: 'bob@test.com',
          isTop: true,
        },
        {
          id: 'sue',
          name: 'Sue',
          phone: '0898 123 345',
          email: 'sue@test.com',
          isTop: false,
        },
      ],
    };
  },
  methods: {
    toggleTopStatus(friendId) {
      const identifiedFriend = this.friends.find(
        (friend) => friend.id === friendId
      );
      identifiedFriend.isTop = !identifiedFriend.isTop;
    },
    addContact(name, phone, email) {
      const newFriendContact = {
        id: new Date().toISOString(),
        name: name,
        phone: phone,
        email: email,
        isTop: false,
      };
      this.friends.push(newFriendContact);
    },
    deleteContact(friendId) {
      this.friends = this.friends.filter((friend) => friend.id !== friendId);
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@200;300;400&display=swap');
* {
  box-sizing: border-box;
}

html {
  font-family: 'Raleway', sans-serif;
}

body {
  min-height: 100vh;
  margin: 0;
  background: rgb(227, 236, 244);
  background: linear-gradient(
    0deg,
    rgba(101, 149, 194, 1) 0,
    rgba(227, 236, 244, 1) 100%
  );
}

header {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  margin: 2rem auto;
  border-radius: 10px;
  padding: 1rem;
  background-color: #060e2c;
  color: white;
  text-align: center;
  width: 90%;
  max-width: 40rem;
}
header h1 {
  font-size: 2rem;
  font-weight: 300;
}

#app ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

#app li,
#app form {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  margin: 1rem auto;
  border-radius: 10px;
  padding: 1rem;
  text-align: center;
  font-weight: 400;
  width: 90%;
  max-width: 40rem;
  background-color: #99d2fb;
}

#app h2 {
  font-size: 2rem;
  font-weight: 300;
  border-bottom: 2px solid #f7f7f7;
  color: #060e2c;
  margin: 0 0 1rem 0;
}

#app button {
  font: inherit;
  font-size: 0.6rem;
  cursor: pointer;
  border: 1px solid #060e2c;
  background-color: #060e2c;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: white;
  padding: 0.5rem 1rem;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.26);
  border-radius: 30px;
  margin: 0.3rem 1rem;
  transition: all 0.2s ease;
}

#app button:hover,
#app button:active {
  background-color: #c2e8fb;
  border-color: #060e2c;
  color: #000;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.26);
  outline: none;
}
#app input {
  font: inherit;
  padding: 0.15rem;
  border-radius: 0.5rem;
  outline: none;
}
#app label {
  margin-right: 1rem;
  font-weight: 400;
  width: 7rem;
  display: inline-block;
  background-color: #99d2fb;
}
#app form div {
  margin: 1rem 0;
  background-color: #99d2fb;
}
</style>
